'use client';

import { motion, type Variants } from 'motion/react';
import { getVariants, useAnimateIconContext, IconWrapper, type IconProps } from './icon';

type DownloadProps = IconProps<keyof typeof animations>;

const animations = {
  default: {
    arrow: {
      initial: { y: 0, transition: { duration: 0.2, ease: 'easeOut' } },
      animate: { y: 2, transition: { duration: 0.2, ease: 'easeInOut' } },
    },
  } satisfies Record<string, Variants>,
} as const;

function IconComponent({ size, ...props }: DownloadProps) {
  const { controls, animation } = useAnimateIconContext();
  const variants = getVariants(animations, animation);

  return (
    <motion.svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
      initial="initial"
      animate={controls}
      {...props}
    >
      <motion.g variants={variants.arrow} initial="initial" animate={controls}>
        <path d="M12 3v11" />
        <path d="m7 9 5 5 5-5" />
      </motion.g>
      <path d="M5 15v4a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2v-4" />
    </motion.svg>
  );
}

function Download(props: DownloadProps) {
  return <IconWrapper icon={IconComponent} {...props} />;
}

export { animations, Download, Download as DownloadIcon, type DownloadProps };
